import React, { useState } from 'react';
import TopHeader from '../../components/TopHeader';
import SabhaSaarHeader from '../../components/SabhaSaarHeader';
import UserInfo from '../../components/UserInfo';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';

const AfterLogin: React.FC = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [error , setError] = useState(false)
 const handleNewUpload = () => {
  const consent = localStorage.getItem("uploadConsent");

  if (consent === "true") {
    navigate('/upload'); 
  } else {
    setShowModal(true); 
  }
};


  const handleAgree = () => {
    setError(false)
    if (isChecked) {
     localStorage.setItem("uploadConsent", "true"); 
      setShowModal(false);
      navigate('/upload');
    } else {
      setError(true)
    }
  };

  const handlePreviousMeeting = () => {
    navigate('/PreviousMeetingsDetails');
  };

  const handleDraftMeeting = () =>{
    navigate('/draftMeetingsDetails');
  }
  return (
    <div>
      <TopHeader />
      <section className="body-content">
        <SabhaSaarHeader />
        <UserInfo />
        <div className="container h-100" id="uploadMainSkip">
          <div className="mt-3">
            <div className='heigthAfterLogin'>
              <div className="gap-3">
                <button 
                  onClick={handleNewUpload} 
                  className="afterLoginBtn afterLoginBtn-silver" 
                  role="button"
                >
                  Generate Minutes
                </button>
                <button 
                  onClick={handlePreviousMeeting} 
                  className="afterLoginBtn afterLoginBtn-orange" 
                  role="button"
                >
                  View Minutes
                </button>

                <button 
                onClick={handleDraftMeeting}
                  className="afterLoginBtn afterLoginBtn-green" 
                  role="button"
                >
                  Draft Minutes
                </button>

              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />

      {/* Confirmation Modal */}
      {showModal && (
        <div 
          className="modal fade show d-block" 
          style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} 
          tabIndex={-1}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content p-3">
              <h5 className="modal-title mb-3">Confirmation</h5>
              <p>
                I confirm that the minutes generated through the Video/Audio uploaded 
                shall be available in the public domain and the uploaded file shall 
                be stored with the Ministry of Panchayati Raj as per its Data Archival policy.
              </p>
              <div className="form-check my-3">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="agreeCheckbox"
                  checked={isChecked}
                  onChange={(e) => setIsChecked(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="agreeCheckbox">
                  I Agree
                </label>
                {error && <p className='text-danger agree'>Please check the box to agree.</p>}
              </div>
              <div className="d-flex justify-content-end gap-2">
                <button 
                  className="btn btn-secondary" 
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button 
                  className="btn btn-primary" 
                  onClick={handleAgree}
                >
                  Agree & Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AfterLogin;
